import React, { ChangeEventHandler } from "react"
import useT from "utils/useT"

type Props = {
  value: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

const NameInput = ({ value, onChange }: Props) => {
  const t = useT()
  return (
    <div className="input-style has-borders has-icon validate-field">
      <i className="fa fa-user" />
      <input
        type="name"
        name="name"
        value={value}
        className="form-control validate-name"
        id="form1a"
        placeholder={t.signup.name}
        onChange={onChange}
      />
      <em>({t.signup.required})</em>
    </div>
  )
}

export default NameInput
